import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { BaseRichService } from '../../../providers/base-rich.service';
import { BaseFormComponent } from '../../shared/base-form/base-form.component';

@Component({
  selector: 'app-contact-from',
  templateUrl: '../../shared/base-form/base-form.component.html',
  styleUrls: ['./contact-from.component.scss']
})
export class ContactFromComponent extends BaseFormComponent implements OnInit {

  constructor(
    public cookieService: CookieService,
    public activeModal: NgbActiveModal,
    public titleService: Title,
    public service: BaseRichService,
    public translator: TranslateService,
  ) {
    super(cookieService, activeModal, titleService, translator, service);
    this.entityName = 'contact';
  }

  async manipulate(data) {
    await super.manipulate(data);
  }

  async customize(field) {
    if (field.name === 'account_id' && (this.formData['account_id'] || this.isEdit)) {
      field.type.name = 'text';
      field.type.readOnly = true;
      field.type.option = undefined;
    }
    await super.customize(field);
  }
}
